/**
 * Constantes de enlace y formato de GeoVis Urbanismo. La web no publica qué
 * municipios están disponibles (decisión del usuario, 2026-10-12): la cobertura crece
 * cada semana y se pregunta al pedir acceso.
 */

export const APP_URBANISMO = 'https://aplicacion.geovis.es/urbanismo';
// Urbanismo no tiene prueba gratuita ni precio público: se pide acceso. Desde 2026-10-14 en la
// propia web (/urbanismo/acceso) y no en la app: el visitante no sale de la landing.
export const URL_SOLICITAR_ACCESO = '/urbanismo/acceso';
// El municipio de demostración de la app (Torquemada), abierto sin sesión.
export const URL_MUNICIPIO_EJEMPLO = `${APP_URBANISMO}/municipio/torquemada`;
